import { render, staticRenderFns } from "./ModalCrearTramo.vue?vue&type=template&id=820331c6&"
import script from "./ModalCrearTramo.vue?vue&type=script&lang=ts&"
export * from "./ModalCrearTramo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('820331c6', component.options)
    } else {
      api.reload('820331c6', component.options)
    }
    module.hot.accept("./ModalCrearTramo.vue?vue&type=template&id=820331c6&", function () {
      api.rerender('820331c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTramos/ModalCrearTramo.vue"
export default component.exports